import styled from "styled-components";
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles<Theme>((theme) => ({
	inputAutoCompleteCheckbox: {
		position: "relative",
		zIndex: 1,

		"& .MuiAutocomplete-inputRoot": {
			background: theme.palette.background.paper,
		},
		"& .MuiSvgIcon-root": {
			color: theme.palette.primary.main,
		},
		"& .Mui-disabled": {
			backgroundColor: "#d7d7d7",
		},
		"& .MuiFormHelperText-root": {
			background: "transparent",
			".MuiChip-label": {
				background: "red",
			},
		},
		"& .MuiFormHelperText-root.Mui-disabled": {
			color: theme.palette.error.main,
		},
	},
	chip: {
		display: "flex",
		justifyContent: "space-between",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		maxWidth: "350px !important",
		[theme.breakpoints.down("xs")]: {
			maxWidth: "200px",
		},
	},
}));

export const Container = styled.div`
	width: 100%;
`;
